import { Flex, Heading, Img, Text } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

import useLayout from '@hook/shared/use-layout'

import { ILayoutMessageProps } from '@base/@types/components/Layout/Message'

const SelectStore: FC<ILayoutMessageProps> = ({ title, message, type }) => {
  const { menuToggle } = useLayout()

  const height = useMemo(() => {
    if (menuToggle) {
      if (type === 'modal') {
        return '528px'
      }
      if (type === 'chartEmpty') {
        return '250px'
      }
      if (type === 'rupture') {
        return '297px'
      }
      return '688px'
    }

    if (!menuToggle) {
      if (type === 'modal') {
        return '528px'
      }
      if (type === 'chart') {
        return '353px'
      }
      if (type === 'chartEmpty') {
        return '250px'
      }
      if (type === 'rupture') {
        return '297px'
      }
      if (type === 'homeGrid') {
        return '320px'
      }
      return '530px'
    }
  }, [menuToggle, type])

  return (
    <Flex
      h={height}
      flexDir="column"
      alignItems="center"
      justifyContent="center"
    >
      <Img
        width="10%"
        src="https://cdn.dribbble.com/users/754943/screenshots/2761885/dribbble-filter.gif"
      />
      <Heading
        size={type === 'chart' || type === 'homeGrid' ? 'md' : 'lg'}
        mb={2}
        mt={0}
      >
        {title}
      </Heading>
      <Text color="gray.500">{message}</Text>
    </Flex>
  )
}

export default SelectStore
